import { Injectable, inject } from '@angular/core';
import { ActivatedRouteSnapshot, Router, RouterStateSnapshot } from '@angular/router';

import { GlobalService } from '@23degrees/shared/services/global/global.service';
import { AuthQuery } from '@23degrees/stores/auth/auth.query';
import { AuthStoreService } from '@23degrees/stores/auth/auth.service';
import { cleanSlug } from '@23degrees/utilities/content.utils';

/**
 * Rules access for the whole plattform this
 * is the place to check if user has access to
 * a page in general
 */
@Injectable({
  providedIn: 'root',
})
export class AuthGuard {
  private router = inject(Router);
  private authService = inject(AuthStoreService);
  private authQuery = inject(AuthQuery);
  private globalService = inject(GlobalService);

  user: any;
  private isServer = this.globalService.isServer();

  private publicPages: Array<string> = [
    '/editor',
    '/tags',
    '/user-profile/',
    '/view',
    '/viewSub',
    '/edit',
    '/editSub',
    '/export',
    '/stream',
    '/blog',
    '/contact',
    '/about',
    '/pricing',
    '/search',
    '/corporate',
    '/covid-19',
    '/covid-19-next',
    '/tutorials',
    '/academy',
    '/dataset',
    '/indicator',
    '/data',
    '/atlas',
    '/solutions',
    // '/home',
    // '/customer-stories'
  ];
  private renderSSR = [
    '/stream',
    '/blog',
    '/user-profile/',
    '/contact',
    '/about',
    '/pricing',
    '/tags',
    '/search',
    '/corporate',
    '/covid-19',
    '/covid-19-next',
    '/tutorials',
    '/dataset',
    '/indicator',
    '/solutions',
    '/academy',
    // '/home',
    // '/customer-stories'
  ];
  private editorPages = ['/view', '/viewSub', '/edit', '/editSub', '/export', '/data'];

  public canActivate = async (route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Promise<any> => {
    return await this.checkUserPermission(route, state);
  };

  public canActivateChild = async (route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Promise<any> => {
    return await this.checkUserPermission(route, state);
  };

  private checkUserPermission = async (route, state) => {
    const url = `/${route.url.join('/')}`;
    try {
      if (!this.isServer) {
        if (!this.authQuery.verified) {
          await this.authService.setupUser();
        }

        this.user = { _id: this.authQuery.getValue().id, token: this.authQuery.getValue().token };
        // console.log('[checkUserPermission] user:', this.user);
      } else {
        if (url === '/' || this.renderSSR.some((ssrUrl) => url.startsWith(ssrUrl))) return true;
        for (const urlStart of this.editorPages) {
          if (url.startsWith(urlStart)) {
            const slugsandBase = url.split('/');
            // console.log("startAndBase: ",slugsandBase);
            if (slugsandBase.length >= 3) {
              const slug = cleanSlug(slugsandBase[2]);
              if (slug && slug.length > 0) {
                // console.log('[ServerSideSlug]');
                if (urlStart !== '/view' && urlStart !== '/export') {
                  this.router.navigate(['/view', slug]);
                  return false;
                }
                return true;
              }
            }
          }
        }
        // get everything to not found
        // this disables ssr for all pages with auth (embed crawler not in)
        this.router.navigate(['/ssrloading']);
        return false;
      }
    } catch (error) {
      // throw error;
      console.log('[AuthGuard] error ', error);
      return false;
    }

    if (!url.startsWith('/embed')) {
      // this.analyticsService.setupGA();
    }

    // setting google analytics user id
    const isAnonUser = this.authQuery.isAnonUser();
    let nonAnonUser = false;
    if (this.user && !isAnonUser) {
      nonAnonUser = true;
    }

    if (nonAnonUser) {
      // set user id in google analyticsService
      // this.analyticsService.setUserid(this.user._id);
    }

    // checking permissions
    // based on where the user wants to go and which user he is / roles he has
    // we also have to check wether the user
    if (url === '/') {
      return true;
    }

    // check public routes
    for (const urlStart of this.publicPages) {
      if (url.startsWith(urlStart)) return true;
    }

    // if no of the above was hit
    if (nonAnonUser) {
      return true;
    }
    console.log('[AuthGuard] - Done goto home');
    this.router.navigate(['/']);
    return false;
  };
}
